import { render, staticRenderFns } from "./CouponSuccess.vue?vue&type=template&id=5f6732cd&scoped=true&"
import script from "./CouponSuccess.vue?vue&type=script&lang=ts&"
export * from "./CouponSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./CouponSuccess.vue?vue&type=style&index=0&id=5f6732cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6732cd",
  null
  
)

export default component.exports